const STORAGE_KEY = "ui:theme";

function getCurrentUserId() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.id ? String(user.id) : null;
  } catch {
    return null;
  }
}

function keyForUser(userId) {
  return userId ? `${STORAGE_KEY}:${userId}` : STORAGE_KEY;
}

export function getStoredTheme() {
  try {
    const userId = getCurrentUserId();
    const value = localStorage.getItem(keyForUser(userId));
    return value === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function setStoredTheme(theme) {
  try {
    const userId = getCurrentUserId();
    localStorage.setItem(keyForUser(userId), theme === "dark" ? "dark" : "light");
  } catch {
    // ignore
  }
}

export function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  const isDark = theme === "dark";
  root.classList.toggle("dark", isDark);
}
